<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Unraveling Taboo: Love’s Unexpected Pathways</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#preface">Preface</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-i-margarita-let-me-i-will-not-hurt-you">Chapter I: Margarita,
          Let Me! I Will Not Hurt You!</a></li>
<li id="toc-li-5"><span href="#/text/ch005#chapter-ii-my-name-is-angela-baron-baptist" title="Link target outside of Sample">Chapter II: My Name Is
          Angela Baron Baptist</span></li>
<li id="toc-li-6"><span href="#/text/ch006#chapter-iii-let-us-go-upstairs-to-my-bedroom" title="Link target outside of Sample">Chapter III: Let Us Go
          Upstairs to My Bedroom!</span></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-iv-the-secret" title="Link target outside of Sample">Chapter IV: The Secret</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-v-intransigence" title="Link target outside of Sample">Chapter V: Intransigence</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-vi-the-theft" title="Link target outside of Sample">Chapter VI: The Theft</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-vii-the-ring" title="Link target outside of Sample">Chapter VII: The Ring</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-viii-violence" title="Link target outside of Sample">Chapter VIII: Violence</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-ix-follow-the-hallucination" title="Link target outside of Sample">Chapter IX: Follow the
          Hallucination</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-x-truth-is-time" title="Link target outside of Sample">Chapter X: Truth is Time</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-xi-a-single-shot-kills-two" title="Link target outside of Sample">Chapter XI: A Single Shot Kills
          Two</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?95d6d896